module.exports = __webpack_public_path__ + "img/card-bg-03.c1b20296.png";